!function(){
  // Only run where product cards live (collections, search, homepage sections)
  

  var LABEL = 'Grab it Now';
  var SKIP = /(choose options|sold out|unavailable|view product)/i;
  var MATCH = /(add to (cart|bag|basket)|quick add|add)$/i;

  function rename(el){
    if(!el || el.dataset.grabbed === '1' || el.closest('.kl-hub-drawer,.kl-hub-modal-veil,.kl-hub-launcher-container')) return;
    var txt = (el.textContent || '').trim();
    var aria = (el.getAttribute('aria-label') || '').trim();

    // Skip non-ATC states
    if (SKIP.test(txt) || SKIP.test(aria) || el.disabled) return;

    // Rename only classic ATC/quick-add labels
    if (MATCH.test(txt) || MATCH.test(aria)) {
      el.textContent = LABEL;                // visible branding
      el.setAttribute('aria-label','Add to cart'); // keep SRs conventional
      el.dataset.grabbed = '1';
    }
  }

  function scan(root){
    var nodes = root.querySelectorAll(
      'button, a[role="button"], .quick-add__submit, .card-product button, .product-card button'
    );
    nodes.forEach(rename);
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  } else {
    scan(document);
  }

  // Watch for new cards (infinite scroll, quick-view, sections)
  new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      var m = muts[i];
      if (!m.addedNodes) continue;
      for (var j=0;j<m.addedNodes.length;j++){
        var n = m.addedNodes[j];
        if (n.nodeType === 1) scan(n);
      }
    }
  }).observe(document.documentElement, {childList:true, subtree:true});
}();
